import React from "react";
import "./tables.css";
import KeyboardDoubleArrowUpSharpIcon from "@mui/icons-material/KeyboardDoubleArrowUpSharp";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import AppDialog from "./appDialog";

const ConfirmPromoteDialog = ({
  cell,
  open,
  envCell,
  handleClickOpen,
  handleClose,
  handleConfirm,
}) => {
  const cellValue = cell.getValue();
  const tooltip = "Promote to " + cell.column.id;
  let env = "";

  if (envCell.current != null) {
    env = envCell.current.id;
  }

  return (
    <>
      {cellValue}
      <IconButton
        color="success"
        size="small"
        sx={{ ml: 0.5, "&:hover": { bgcolor: "action.hover" } }}
        onClick={() => handleClickOpen(cell)}
      >
        <Tooltip id="button-report" title={tooltip}>
          <KeyboardDoubleArrowUpSharpIcon fontSize="small" />
        </Tooltip>
      </IconButton>

      <AppDialog
        open={open}
        onClose={handleClose}
        title={`Promote to ${env}`}
        maxWidth="xs"
        actions={
          <>
            <Button variant="text" color="inherit" onClick={handleClose}>
              Cancel
            </Button>
            <Button variant="contained" color="primary" onClick={handleConfirm}>
              Promote
            </Button>
          </>
        }
      >
        <Typography variant="body2" color="text.secondary">
          This record doesn't exist in {env} yet. Do you want to proceed with
          promoting it there?
        </Typography>
      </AppDialog>
    </>
  );
};

export default ConfirmPromoteDialog;
